import { ExperimentVariants } from '../types/client-data';

export const convertBooleanToAB = (value: boolean | string | undefined): ExperimentVariants => {
    if (typeof value === 'string') {
        if (['ON', 'OFF'].includes(value)) {
            return value === 'OFF' ? 'A' : 'B';
        } else {
            return value as ExperimentVariants;
        }
    }

    return !value ? 'A' : 'B';
};
